import { useEffect } from 'react';
import { ProductLine, ReceiptData } from '../types';
import { Button } from './ui/Button';
import { playCallbackSound } from 'utils/sounds';

interface CallbackScreenProps {
  receiptData: ReceiptData | null;
  productLine: ProductLine | null;
  loading: boolean;
  handleCancel: () => void;
  onConfirm: () => void;
  handleProblem: () => void;
}

const InfoRowWhite = ({ label, value }: { label: string; value?: string | number | null }) => (
  <div className="flex items-baseline gap-2">
    <span className="w-16 shrink-0 text-xs font-semibold text-orange-100">{label}</span>
    <span className="text-sm font-semibold text-white break-all">{value ?? 'N/A'}</span>
  </div>
);

export const CallbackScreen = ({
  receiptData,
  productLine,
  loading,
  handleCancel,
  onConfirm,
  handleProblem,
}: CallbackScreenProps) => {
  useEffect(() => {
    playCallbackSound();
  }, []);

  return (
    <div className="-mx-4 -mb-6 flex min-h-full flex-col px-6 pb-6 pt-4">
      <div className="mb-5 text-center">
        <p className="text-5xl font-black uppercase tracking-widest text-white leading-none">
          CALLBACK
        </p>
        <p className="mt-2 text-sm font-bold uppercase tracking-wide text-orange-100">
          Do not put away — handle callback
        </p>
      </div>

      <p className="mb-4 text-center text-base font-bold text-white">
        Tracking# {receiptData?.tracking_id || receiptData?.receipt?.tracking_id}
      </p>

      {productLine?.style_image_url && (
        <div className="mb-4 flex justify-center rounded-xl border border-white/20 bg-white/10 p-3">
          <img
            src={productLine.style_image_url}
            alt="Product"
            className="max-h-40 max-w-full rounded-lg object-contain"
          />
        </div>
      )}

      <div className="mb-4 rounded-xl border border-white/20 bg-white/10 p-4 space-y-2">
        <InfoRowWhite label="Article" value={productLine?.product_id} />
        <InfoRowWhite label="Color" value={productLine?.style_color} />
        <InfoRowWhite label="Size" value={productLine?.product_size} />
      </div>

      <div className="mt-auto space-y-3">
        <Button
          type="button"
          className="h-14 w-full rounded-2xl bg-white text-lg font-bold text-orange-700 shadow-lg hover:bg-orange-50"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="button"
          className="h-14 w-full rounded-2xl bg-white/20 border-2 border-white text-lg font-bold text-white shadow-lg hover:bg-white/30"
          onClick={onConfirm}
          disabled={loading}
        >
          Continue to Grade
        </Button>
        <Button
          type="button"
          className="h-14 w-full rounded-2xl bg-white/20 border-2 border-white text-lg font-bold text-white shadow-lg hover:bg-white/30"
          onClick={handleProblem}
          disabled={loading}
        >
          {loading ? 'Reporting...' : 'Problem'}
        </Button>
      </div>
    </div>
  );
};
